/**
 * @desc 获取审批流程图
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.ResponseDto<string>;
export function request(
  instId: string | number,
  params: API.activiti.bpmApprovaTask.getBpmImage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/getBpmImage/${instId}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
